import { render, staticRenderFns } from "./FreeDeliveryNotice.vue?vue&type=template&id=652ea226"
import script from "./FreeDeliveryNotice.vue?vue&type=script&lang=ts"
export * from "./FreeDeliveryNotice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports